module.exports = __webpack_public_path__ + "img/Nato.4f95d1a7.svg";